"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _survey = require("@/api/survey");
var _cookie = require("@/utils/cookie");
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SurveyDebug',
  props: {
    category: String,
    subcategory: String
  },
  data() {
    return {
      domain: 'https://survey-dev.ownthelab.com/',
      fullscreenloading: false,
      participantList: [],
      surveyId: ''
    };
  },
  created() {
    console.log('Load Debug Page');
    this.surveyId = this.$route.params.id;
    if (this.subcategory === 'self-assessment') {
      this.getPartcipants();
    } else {
      this.getMGHSurveyBossPeerDMs();
    }
  },
  methods: {
    getPartcipants() {
      const id = this.$route.params.id;
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.fullscreenloading = true;
      (0, _survey.getHikeParticipantBySurveyId)(token, id).then(response => {
        const d = response.data;
        this.participantList = d;
        console.log('participant List', this.participantList);
        this.fullscreenloading = false;
      }).catch(error => {
        showDebugLog('survey-getSurveyById-error', error);
        this.fullscreenloading = false;
        displayPopupMessage(error, 'error');
      });
    },
    getMGHSurveyBossPeerDMs() {
      const id = this.$route.params.id;
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.fullscreenloading = true;
      (0, _survey.getMGHSurveyBossPeerDMList)(token, id).then(response => {
        const d = response.data;
        this.participantList = d;
        console.log('participant List', this.participantList);
        this.fullscreenloading = false;
      }).catch(error => {
        showDebugLog('survey-getSurveyById-error', error);
        this.fullscreenloading = false;
        displayPopupMessage(error, 'error');
      });
    }
  }
};